import moment from "moment/moment";

 export const convertUTCToLocalTime = (
    end_date,
    end_time,
    format = "DD MMM YYYY hh:mm a"
  ) => {
    const utcDateTime = moment.utc(
      `${end_date} ${end_time}`,
      "YYYY-MM-DD HH:mm:ss"
    );
    const localDateTime = utcDateTime.local();
    return localDateTime.format(format);
  };